import { AbstractQuery } from 'src/models/query';

export class GetTheUserDetailsOfTheAuthenticatedUserQuery extends AbstractQuery {
	cacheable = false;
	name = 'IFS_User_Query_Queries_GetTheUserDetailsOfTheAuthenticatedUserQuery';
	sort = [];

	constructor() {
		super();
	}
}

export class GetTheUserConfigurationAndEffectiveRightsQuery extends AbstractQuery {
	public apiVersion = 2;
	cacheable = false;
	name = 'IFS_Authorisation_Query_Queries_GetTheUserConfigurationAndEffectiveRightsQuery';
	sort = [];

	constructor() {
		super();
	}
}
